import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import ModalQR from "../components/ModalQR";
import { useEffect, useState } from "react";
import axios from "../lib/AxiosGo";
import { toast } from "react-toastify";

const DevicePage = () => {
  const closeBtn = document.querySelector('.btn-close[data-bs-dismiss="modal"]');
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [qrCode, setQrCode] = useState(null);
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [formData, setFormData] = useState({
    device_id: '',
    device_name: '',
    device_number: ''
  });
  const [isEdit, setIsEdit] = useState(false);

  const handleSubmit = () => {
    if (isEdit) {
      handleUpdate(formData.device_id);
    } else {
      addDevice();
    }
  };

  const getData = async () => {
    try {
      const response = await axios.get('/devices/data');
      setData(response.data);
    } catch (error) {
      console.error('Error fetching device data:', error);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedDeviceId("");
    setQrCode(null);
  };

  const addDevice = async () => {
    try {
      const response = await axios.post('/devices/store', formData);
      toast.success("Device berhasil ditambahkan! Menyiapkan koneksi Baileys...");
      getData();
      setFormData({ device_name: '', device_number: '' });
      if (closeBtn) {
        closeBtn.click();
      }
      if (response.data?.device?.device_id) {
        setSelectedDeviceId(response.data.device.device_id);
      }
    } catch (error) {
      console.error('Error adding device:', error);
      toast.error("Gagal menambahkan device");
    }
  };

  const handleDelete = async (deviceId) => {
    if (!window.confirm(`Yakin ingin menghapus device ${deviceId}?`)) return;
    try {
      await axios.delete(`/devices/${deviceId}`);
      toast.success(`Device ${deviceId} berhasil dihapus!`);
      getData();
    } catch (error) {
      console.error('Error deleting device:', error);
      toast.error("Gagal menghapus device");
    }
  };

  const handleEdit = (row) => {
    setFormData({
      device_id: row.device_id,
      device_name: row.device_name,
      device_number: row.device_number
    });
    setIsEdit(true);
  };

  const handleUpdate = (device_id) => {
    axios.put(`/devices/${device_id}`, formData)
      .then(() => {
        toast.success("Device berhasil diperbarui!");
        getData();
        setFormData({ device_name: '', device_number: '' });
        setIsEdit(false);
        if (closeBtn) {
          closeBtn.click();
        }
      })
      .catch((err) => {
        console.error("Gagal update device:", err);
        toast.error("Gagal update device");
      });
  };

  const getQR = async (deviceId) => {
    setSelectedDeviceId(deviceId);
    setQrCode(null);
    setModalOpen(true);

    try {
      // Trigger connect socket if needed
      await axios.post(`/devices/connect/${deviceId}`).catch(() => {});
      const response = await axios.get(`/devices/qr/${deviceId}`);
      setQrCode(response.data.qr);
    } catch (error) {
      // QR will be delivered over Socket.IO if not yet cached
      console.log('Menunggu QR code dari Socket.IO...');
    }
  };

  const handleDisconnect = async (deviceId) => {
    try {
      await axios.post(`/devices/disconnect/${deviceId}`);
      toast.info(`Device ${deviceId} berhasil diputus.`);
      getData();
    } catch (error) {
      console.error('Error disconnecting device:', error);
      toast.error("Gagal memutuskan koneksi device");
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title='Manajemen Device WhatsApp Bot' />

        <div className="card h-100 radius-12 border-0 shadow-sm">
          <div className="card-header py-16 px-24 bg-base d-flex align-items-center gap-1 justify-content-between border border-end-0 border-start-0 border-top-0">
            <div>
              <h5 className="card-title text-lg text-primary-light mb-0">
                Informasi Device WhatsApp (Baileys Engine)
              </h5>
              <p className="text-xs text-muted mb-0">Kelola nomor WA untuk bot pengaduan kepolisian</p>
            </div>
            <Link
              to="#"
              className="btn btn-primary-600 px-16 py-10 d-inline-flex align-items-center gap-2 radius-8"
              onClick={() => { setIsEdit(false); setFormData({ device_name: '', device_number: '' }); }}
              data-bs-toggle="modal"
              data-bs-target="#addDeviceModal"
            >
              <Icon icon="iconamoon:sign-plus-circle-duotone" className="text-xl" /> Tambah Device
            </Link>
          </div>
          <div className="card-body p-16">
            <div className="table-responsive">
              <table className="table vertical-striped-table mb-0 align-middle">
                <thead>
                  <tr>
                    <th>Nama Device</th>
                    <th>Nomor WhatsApp</th>
                    <th>Status Koneksi</th>
                    <th className="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length !== 0 ? (
                    data.map((device) => (
                      <tr key={device.device_id}>
                        <td className="fw-semibold text-primary-light">
                          <Icon icon="logos:whatsapp-icon" className="me-2" />
                          {device.device_name}
                          <span className="text-xs text-muted d-block">{device.device_id}</span>
                        </td>
                        <td>{device.device_number || "-"}</td>
                        <td>
                          {device.status === 'connected' ? (
                            <span className="badge bg-success-100 text-success-700 px-12 py-6 radius-8 d-inline-flex align-items-center gap-1">
                              <Icon icon="mdi:circle" className="text-xs" /> Terhubung (Online)
                            </span>
                          ) : (
                            <span className="badge bg-danger-100 text-danger-700 px-12 py-6 radius-8 d-inline-flex align-items-center gap-1">
                              <Icon icon="mdi:circle" className="text-xs" /> Terputus (Offline)
                            </span>
                          )}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 me-2"
                            title="Edit"
                            onClick={() => handleEdit(device)}
                            data-bs-toggle="modal"
                            data-bs-target="#addDeviceModal"
                          >
                            <Icon icon="iconamoon:edit-fill" /> Edit
                          </button>
                          
                          {device.status === 'connected' ? (
                            <button
                              className="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1 me-2"
                              onClick={() => handleDisconnect(device.device_id)}
                              title="Disconnect"
                            >
                              <Icon icon="iconamoon:disconnect-duotone" /> Disconnect
                            </button>
                          ) : (
                            <button
                              className="btn btn-sm btn-success d-inline-flex align-items-center gap-1 me-2"
                              onClick={() => getQR(device.device_id)}
                              data-bs-toggle="modal"
                              data-bs-target="#connectDeviceModal"
                              title="Hubungkan & Scan QR"
                            >
                              <Icon icon="iconamoon:link-duotone" /> Scan QR
                            </button>
                          )}

                          <button
                            className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-1"
                            onClick={() => handleDelete(device.device_id)}
                            title="Hapus"
                          >
                            <Icon icon="iconamoon:trash-fill" /> Hapus
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-24 text-muted">
                        Belum ada device WhatsApp yang ditambahkan.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Modal Add/Edit Device */}
            <div
              className="modal fade"
              id="addDeviceModal"
              tabIndex="-1"
              aria-labelledby="addDeviceModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content radius-12 border-0 shadow-lg">
                  <div className="modal-header bg-primary-50 py-16 px-24 border-bottom">
                    <h5 className="modal-title text-primary-600" id="addDeviceModalLabel">
                      {isEdit ? "Edit Device" : "Tambah Device Baru"}
                    </h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div className="modal-body p-24">
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                      <div className="mb-16">
                        <label htmlFor="deviceName" className="form-label text-sm font-semibold">Nama Device / Kantor</label>
                        <input
                          onChange={(e) => setFormData({ ...formData, device_name: e.target.value })}
                          value={formData.device_name}
                          type="text"
                          className="form-control"
                          id="deviceName"
                          placeholder="Contoh: Bot Polda Renakta"
                          required
                        />
                      </div>
                      <div className="mb-16">
                        <label htmlFor="deviceNumber" className="form-label text-sm font-semibold">Nomor WhatsApp</label>
                        <input
                          onChange={(e) => setFormData({ ...formData, device_number: e.target.value })}
                          value={formData.device_number}
                          type="text"
                          className="form-control"
                          id="deviceNumber"
                          placeholder="Contoh: 628123456789"
                          disabled={isEdit}
                        />
                        <span className="text-xs text-muted mt-4 d-block">Gunakan format internasional tanpa tanda plus (+), contoh: 628123456789</span>
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer border-top py-12 px-24 bg-light">
                    <button type="button" className="btn btn-secondary px-20" onClick={handleClose} data-bs-dismiss="modal">
                      Batal
                    </button>
                    <button type="button" className="btn btn-primary px-20" onClick={handleSubmit}>
                      {isEdit ? "Simpan Perubahan" : "Simpan & Inisialisasi"}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Connect Modal with Baileys QR Code */}
            <ModalQR
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              qrCode={qrCode}
              selectedDeviceId={selectedDeviceId}
              getData={getData}
            />
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default DevicePage;
